import type { DivisionLookup } from '../types/division-lookup.type';
import { GuidNameCodeModel } from './guid-name-code.model';
import { HubLookupModel } from './hub-lookup.model';

export class DivisionLookupModel
  extends GuidNameCodeModel
  implements DivisionLookup
{
  readonly hubs: HubLookupModel[] | null = null;

  get children(): HubLookupModel[] | null {
    return this.hubs;
  }

  constructor(data: DivisionLookup) {
    super(data);

    if (data.hubs) {
      this.hubs = data.hubs.map((item) => new HubLookupModel(item));
    }
  }
}
